import React from "react";
import { Box, ClassNameMap, Grid, Typography } from "@mui/material";
import { AdditionalData } from "./ItemDetailViewSection";
import OptionSwitch from "../formElements/OptionSwitch";
import pageStyles from "./../../pages/pageStyles";

interface ItemDetailAdditionalData {
  additionalData: AdditionalData[];
  styles: ClassNameMap;
}
const ItemDetailAdditionalData = ({
  additionalData,
  styles,
}: ItemDetailAdditionalData) => {
  const classes = pageStyles();

  return (
    <Grid item xs={12}>
      <hr className={styles.devide} />
      <Typography gutterBottom className={classes.sectionHeadingTitleChild}>
        Additional Data
      </Typography>
      {additionalData.map((data, index) => (
        <Grid key={index} item xs={12} className={classes.additionalDataBox}>
          <Box>
            <Box mb={1}>
              <Typography display="block" className={styles.textTitle}>
                Tag: {data.Tag}
              </Typography>
            </Box>
            <Box mb={1} className={classes.truncate}>
              <Typography display="block" className={styles.textTitle}>
                Value: {data.Value}
              </Typography>
            </Box>
            <Box>
              <Typography display="block" className={styles.textTitle}>
                <OptionSwitch
                  isDisabled
                  isDefaultChecked={data.Encrypted as boolean}
                />
                Encrypted
              </Typography>
            </Box>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default ItemDetailAdditionalData;
